var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.locale === _vm.LOCAL_FR)?_c('LinkToolsFrenchLinks',{attrs:{"links":_vm.links}}):_c('LinkToolsEnglishLinks',{attrs:{"links":_vm.links}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }